"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _style = _interopRequireDefault(require("./style.css"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var _default = exports["default"] = function _default(settings, callbackHandler) {
  return function (_ref) {
    var value = _ref.value,
      row = _ref.row;
    var name = row[settings.namePath];
    var count = row[settings.countPath];
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: "nameCountContainer text-center ".concat(_style["default"].nameCount),
      key: row
    }, ' ', "".concat(name, " (").concat(count, ")"), ' ');
  };
};